import * as ewe from "@eyeo/webext-ad-filtering-solution";
import ServerMessages from "~/servermessages";
import { getAAStatus } from "~/telemetry/background";
import { getMatchingDomain, hasUbo, uboDetectionWasActive } from "./shared";
async function handlePageLoaded(page) {
    if (typeof page.id === "undefined" || page.id === browser.tabs.TAB_ID_NONE) {
        return;
    }
    const domain = await getMatchingDomain(page.url.hostname);
    if (!domain) {
        return;
    }
    let pageState = 0;
    pageState |= (await hasUbo()) ? 1 : 0;
    pageState <<= 1;
    pageState |= (await uboDetectionWasActive()) ? 1 : 0;
    pageState <<= 1;
    pageState |= (await isTabAllowlisted(page.id)) ? 1 : 0;
    pageState <<= 1;
    pageState |= (await isTabPrivate(page.id)) ? 1 : 0;
    pageState <<= 1;
    pageState |= (await isAcceptableAdsEnabled()) ? 1 : 0;
    ServerMessages.recordAnonymousMessage("pageview", "stats", null, {
        misc_text: domain,
        var: pageState,
    });
}
async function isAcceptableAdsEnabled() {
    const status = await getAAStatus();
    return status === "1" || status === "2";
}
async function isTabAllowlisted(tabId) {
    const allowingFilters = await ewe.filters.getAllowingFilters(tabId);
    return allowingFilters.length > 0;
}
async function isTabPrivate(tabId) {
    const tab = await browser.tabs.get(tabId);
    return tab.incognito;
}
export function start() {
    ext.pages.onLoaded.addListener(handlePageLoaded);
}
